// extracted by mini-css-extract-plugin
export default {"columnsLabelsHeader":"columns-labels-header_columnsLabelsHeader__kqPO-","title":"columns-labels-header_title__LZ52G","description":"columns-labels-header_description__D6t76"};